import { MessageDesignTokens } from '@primeuix/themes/types/message';
import { createMessageTokens } from '../tokens/components.js';
import { type SemanticTokens, SEMANTIC } from '../tokens/semantic.js';

/**
 * Message Component Configuration
 */
export function createMessage(s: SemanticTokens): MessageDesignTokens {
  const messageTokens = createMessageTokens(s);
  return {
      root: { borderRadius: messageTokens.base.radius, borderWidth: '1px' },
      content: { padding: messageTokens.base.paddingX, gap: messageTokens.base.gap },
      text: { fontSize: messageTokens.base.bodyFontSize, fontWeight: messageTokens.base.bodyFontWeight },
      simple: { content: { padding: '0' } },
      icon: { size: messageTokens.base.iconSize },
      colorScheme: {
        light: {
          success: { background: messageTokens.success.bg, borderColor: messageTokens.success.border, color: messageTokens.success.fg, shadow: 'none' },
          info: { background: messageTokens.info.bg, borderColor: messageTokens.info.border, color: messageTokens.info.fg, shadow: 'none' },
          warn: { background: messageTokens.warning.bg, borderColor: messageTokens.warning.border, color: messageTokens.warning.fg, shadow: 'none' },
          error: { background: messageTokens.danger.bg, borderColor: messageTokens.danger.border, color: messageTokens.danger.fg, shadow: 'none' },
          secondary: { background: messageTokens.secondary.bg, borderColor: messageTokens.secondary.border, color: messageTokens.secondary.fg, shadow: 'none' },
        },
      },
      css: () => `
        :root .p-message .p-message-content .p-message-icon {
          align-self: baseline;
        }

        /* Review variant: card-like message used in rental wizard review step */
        p-message[pMessageReview],
        p-message[pmessagereview] {
          --p-message-border-width: 0;
          --p-message-success-border-color: transparent;
          --p-message-warn-border-color: transparent;
          --p-message-error-border-color: transparent;
          --p-message-secondary-border-color: transparent;
          --p-message-info-border-color: transparent;
          --p-message-success-shadow: ${messageTokens.base.shadow};
          --p-message-warn-shadow: ${messageTokens.base.shadow};
          --p-message-error-shadow: ${messageTokens.base.shadow};
          --p-message-secondary-shadow: ${messageTokens.base.shadow};
          --p-message-info-shadow: ${messageTokens.base.shadow};
        }

        p-message[pMessageReview] > .p-message,
        p-message[pmessagereview] > .p-message {
          border: none !important;
          border-width: 0 !important;
          border-color: transparent !important;
          outline: none !important;
          border-inline-width: 0 !important;
          border-block-width: 0 !important;
          border-inline-start-width: 0 !important;
          border-inline-end-width: 0 !important;
          box-shadow: ${messageTokens.base.shadow};
        }

        p-message[pMessageReview] .p-message-content,
        p-message[pmessagereview] .p-message-content {
          align-items: flex-start;
          gap: 10px;
          padding: ${messageTokens.base.paddingY};
          border: none !important;
          outline: none !important;
          border-inline-width: 0 !important;
          border-block-width: 0 !important;
        }

        p-message[pMessageReview] .p-message-icon,
        p-message[pmessagereview] .p-message-icon {
          margin-top: 2px;
        }

        p-message[pMessageReview] > .p-message.p-message-success,
        p-message[pmessagereview] > .p-message.p-message-success {
          background: ${messageTokens.success.bg};
          color: ${messageTokens.success.fg};
          border: none !important;
          border-color: transparent !important;
        }

        p-message[pMessageReview] > .p-message.p-message-warn,
        p-message[pmessagereview] > .p-message.p-message-warn {
          background: ${messageTokens.warning.bg};
          color: ${messageTokens.warning.fg};
          border: none !important;
          border-color: transparent !important;
        }

        p-message[pMessageReview] > .p-message.p-message-error,
        p-message[pmessagereview] > .p-message.p-message-error {
          background: ${messageTokens.danger.bg};
          color: ${messageTokens.danger.fg};
          border: none !important;
          border-color: transparent !important;
        }
      `
      };
}
export const message = createMessage(SEMANTIC);